import './app/sentry.config';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import './app/kendo-locales';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
